"use strict";
//
// All component javascript libraries should be included here as the
// demo component has been included for example.
// As the demo component is just included for demonstration purposes it should
// be removed at some point.
//
import initializeFaqCopy from '../components/02-components/faq/faq-copy';
import initializeFaq from '../components/02-components/faq/faq';
import initializeFaqGtmTracking from '../components/02-components/faq/faq-gtm';
//
// Below is the main function that gets called as soon as the DOM is
// ready.
//

document.addEventListener('DOMContentLoaded', function () {
  initializeFaqCopy();
  initializeFaq();
  initializeFaqGtmTracking();
});
